/* @flow */
import * as React from 'react';
import { css, names } from 'linaria';

import Colors from '../constants/Colors';

function Spinner({
  color = Colors.Indigo,
  size = 24,
  style,
  className,
}: {
  color?: string,
  size?: number,
  style?: Object,
  className?: string,
}) {
  return (
    <div
      className={names(Styles.Container, className)}
      style={{ width: size, height: size, ...style }}>
      <div
        className={Styles.Spinner}
        style={{
          borderTopColor: color,
          borderLeftColor: color,
          borderRightColor: color,
        }}
      />
    </div>
  );
}

const Styles = {
  Container: css`
    margin: -2px 0;
  `,
  Spinner: css`
    width: 100%;
    height: 100%;
    border-style: solid;
    border-width: 2px;
    border-color: transparent;
    border-radius: 50%;
    animation: spin 600ms linear infinite;
    @keyframes spin {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }
  `,
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/ui/components/Spinner.js